<template>
  <div>
    <div
      class="BgEmotionChartLabels-container"
      v-for="section in sections"
      :key="section.id"
    >
      <div
        class="BgEmotionChartLabels--large"
        v-bind:style="{ left: getLeft(section.timestamp_start) }"
      ></div>
      <div
        class="BgEmotionChartLabels--large"
        v-bind:style="{ left: getLeft(section.timestamp_end) }"
      ></div>
    </div>
  </div>
</template>

<style scoped>
@import "./styles.css";
</style>

<script>
import moment from "moment";
export default {
  name: "sections",
  props: ["data", "duration"],
  data() {
    return {
      sections: this.data.sections.filter((s) => s.label),
    };
  },
  methods: {
    getLeft(start) {
      const diff = moment(start).diff(this.data.started_at, "milliseconds");
      return (diff / (this.duration * 1000)) * 100 + "%";
    },
  },
};
</script>
